import { createStore, combineReducers } from 'redux';
import authReducer from './reducers/authReducer';
import memberReducer from './reducers/memberReducer';
import orderIdReducer from './reducers/orderIdReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  member: memberReducer,
  orderIDSdkReducer: orderIdReducer,
});

const store = createStore(rootReducer);

export default store;
